import { useQueryClient } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useCreateCustomPageTemplateTestIds = pathgen('useCreateCustomPageTemplateTestIds');
export const useCreateCustomPageTemplate = function useCreateCustomPageTemplate() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (param)=>{
            let { businessId, data } = param;
            return api.customPageTemplates.create(businessId, data);
        },
        toasts: {
            successMessage: t.customPages.templates.createSuccess(),
            successTestId: useCreateCustomPageTemplateTestIds.SuccessToast(),
            errorTestId: useCreateCustomPageTemplateTestIds.ErrorToast()
        },
        onSuccess: (result)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.CustomPageTemplates
                ]
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
        }
    });
    return {
        createTemplate: mutate,
        isLoading
    };
};
